module.exports = __webpack_public_path__ + "img/Patch7.1.a87b3414.webp";